export enum Commerce {
  INTERSECTION_ID = 'in-view',
  TRUE = 'true',
  FALSE = 'false',
  SIDE_BAR = 'sideBar',
  DRAWER_POPUP = 'drawerPopup',
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
  MOBILE_PORTRAIT = 'mobilePortrait',
  MOBILE_LANDSCAPE = 'mobileLandscape',
  DESKTOP_LANDSCAPE = 'desktopLandscape',
  DESKTOP_PORTRAIT = 'desktopPortrait',
  ORIENTATION_LANDSCAPE = '(orientation: landscape)',
  ORIENTATION_PORTRATIT = '(orientation: portrait)',
  Ad = 'Ad',
  SHOP = 'Shop',
  CLOSE = 'close',
  CLOSE_ICON = 'Close Icon',
  AD_LOGO = 'adLogo',
  SHOP_ICON = 'Shop Icon',
  SHOP_ICON_IMG = 'shopIcon',
  COMMERCE_BANNER = 'commerceBanner',
  EMPTY_WISHLIST = 'emptyWishlist',
  TITLE = 'Buy on <name>',
  SHOW_TOAST = 'showToast',
  WISHLIST = 'Wishlist',
  WISHLISTED = 'wishlisted',
  WISHLIST_ICON = 'Wishlist Icon',
  WISHLIST_LOWERCASE = 'wishlist',
  WISHLIST_NUM = 'Wishlist (<num>)',
  IMG_PATH = '/webapp-assets/images/<name>.svg',
  ADD_WISHLIST = 'Add to wishlist',
  REMOVE_WISHLIST = 'Remove from wishlist',
  COMMERCE_FEATURE_FLAG = 'commerce_feature_flag',
  EMPTY_WISHLIST_TEXT = 'As you watch, tap the heart icon to save your favourite looks!'
}
